import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csColorBackground, csColorBorder, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const csePaper = {
  borderRadius: css`var(--cse-paper-border-radius, ${csBorder.radiusMinimal})`,
  rowGap: css`var(--cse-paper-row-gap, ${csSpacing.spacing05})`,
  headingGap: css`var(--cse-paper-heading-gap, ${csSpacing.spacing04})`,
  paddingBlock: css`var(--cse-paper-padding-y, ${csSpacing.spacing06})`,
  paddingInline: css`var(--cse-paper-padding-x, ${csSpacing.spacing06})`,
  height: css`var(--cse-paper-height, auto)`,
  smallPaddingBlock: css`var(--cse-paper-small-padding-y, ${csSpacing.spacing05})`,
  smallPaddingInline: css`var(--cse-paper-small-padding-x, ${csSpacing.spacing05})`,
  largePaddingBlock: css`var(--cse-paper-large-padding-y, ${csSpacing.spacing07})`,
  largePaddingInline: css`var(--cse-paper-large-padding-x, ${csSpacing.spacing07})`,
  extraLargePaddingBlock: css`var(--cse-paper-extra-large-padding-y, ${csSpacing.spacing08})`,
  extraLargePaddingInline: css`var(--cse-paper-extra-large-padding-x, ${csSpacing.spacing08})`,

  primaryBackgroundColor: css`var(--cse-paper-primary-background-color, ${csColorBackground.primary})`,
  secondaryBackgroundColor: css`var(--cse-paper-secondary-background-color, ${csColorBackground.secondary})`,
  errorBackgroundColor: css`var(--cse-paper-error-background-color, ${csColorBackground.error})`,
  infoBackgroundColor: css`var(--cse-paper-info-background-color, ${csColorBackground.info})`,
  successBackgroundColor: css`var(--cse-paper-success-background-color, ${csColorBackground.success})`,
  warningBackgroundColor: css`var(--cse-paper-warning-background-color, ${csColorBackground.warning})`,

  borderedBackgroundColor: css`var(--cse-paper-bordered-background-color, ${csColorBackground.primary})`,
  borderedBorderWidth: css`var(--cse-paper-bordered-border-width, ${csBorder.width})`,
  borderedPrimaryBorderColor: css`var(--cse-paper-bordered-primary-border-color, ${csColorBorder.light})`,
  borderedSecondaryBorderColor: css`var(--cse-paper-bordered-secondary-border-color, ${csColorBorder.dark})`,
  borderedErrorBorderColor: css`var(--cse-paper-bordered-error-border-color, ${csColorFunctional.error})`,
  borderedInfoBorderColor: css`var(--cse-paper-bordered-info-border-color, ${csColorFunctional.info})`,
  borderedSuccessBorderColor: css`var(--cse-paper-bordered-success-border-color, ${csColorFunctional.success})`,
  borderedWarningBorderColor: css`var(--cse-paper-bordered-warning-border-color, ${csColorFunctional.warning})`,

  flexDirection: css`var(--cse-paper-flex-direction, column)`
}

export const style: CSSResult = css`
  .cse-paper {
    border-radius: ${csePaper.borderRadius};
    display: flex;
    flex-direction: ${csePaper.flexDirection};
    row-gap: ${csePaper.rowGap};
    padding-block: ${csePaper.paddingBlock};
    padding-inline: ${csePaper.paddingInline};
    height: ${csePaper.height};
  }

  .heading {
    align-items: center;
    display: flex;
    gap: ${csePaper.headingGap};
  }

  .hidden {
    display: none;
  }

  .bordered {
    border-width: ${csePaper.borderedBorderWidth};
    border-style: solid;
  }

  /* VARIANTS */
  .variant-primary {
    background-color: ${csePaper.primaryBackgroundColor};
  }
  .bordered.variant-primary {
    background-color: ${csePaper.borderedBackgroundColor};
    border-color: ${csePaper.borderedPrimaryBorderColor};
  }

  .variant-secondary {
    background-color: ${csePaper.secondaryBackgroundColor};
  }
  .bordered.variant-secondary {
    background-color: ${csePaper.borderedBackgroundColor};
    border-color: ${csePaper.borderedSecondaryBorderColor};
  }

  .variant-error {
    background-color: ${csePaper.errorBackgroundColor};
  }
  .bordered.variant-error {
    background-color: ${csePaper.borderedBackgroundColor};
    border-color: ${csePaper.borderedErrorBorderColor};
  }

  .variant-info {
    background-color: ${csePaper.infoBackgroundColor};
  }
  .bordered.variant-info {
    background-color: ${csePaper.borderedBackgroundColor};
    border-color: ${csePaper.borderedInfoBorderColor};
  }

  .variant-success {
    background-color: ${csePaper.successBackgroundColor};
  }
  .bordered.variant-success {
    background-color: ${csePaper.borderedBackgroundColor};
    border-color: ${csePaper.borderedSuccessBorderColor};
  }

  .variant-warning {
    background-color: ${csePaper.warningBackgroundColor};
  }
  .bordered.variant-warning {
    background-color: ${csePaper.borderedBackgroundColor};
    border-color: ${csePaper.borderedWarningBorderColor};
  }

  .cse-paper.size-small {
    padding-block: ${csePaper.smallPaddingBlock};
    padding-inline: ${csePaper.smallPaddingInline};
  }
  .size-large {
    padding-block: ${csePaper.largePaddingBlock};
    padding-inline: ${csePaper.largePaddingInline};
  }
  .size-extra-large {
    padding-block: ${csePaper.extraLargePaddingBlock};
    padding-inline: ${csePaper.extraLargePaddingInline};
  }
`
